export default {
  title: 'Notificaciones push',
  description: 'Envía notificaciones push segmentadas a tus clientes',
  buttons: {
    new_campaign: 'Nueva campaña',
  },
  error_messages: {
    no_mobile_app: {
      title: 'La app móvil aún no está activa',
      description: 'Espera a que la app móvil esté activa antes de enviar notificaciones push',
    },
  },
};
